import { connect } from "react-redux";
import get from "lodash/get";

import {
  getPositions as onGetPositions,
  setPositionsData as onSetPositionsData,
  setPositionsPage as onSetPositionsPage,
  setCurrentPositionDate as onSetCurrentPositionDate,
  setPositionsTableData as onSetPositionsTableData,
  setPositionsTableScroll as onSetPositionsTableScroll,
} from "./../../actions/positionsActions";

const mapStateToProps = (state) => ({
  positionsDataState: state.positions.dataState,
  positionsCount: get(state, ["positions", "count"], 0),
  positionsInformation: get(state, ["positions", "information"], []),
  positionsData: get(state, ["positions", "data"], []),
  positionsTableData: get(state, ["positions", "tableData"]),
  positionsErrors: get(state, ["positions", "errors"], []),
  positionsPage: get(state, ["positions", "page"], 1),
  currentPositionDate: get(state, ["positions", "currentDate"], null),
  positionsTablePageData: get(state, ["positions", "tablePageData"], {}),
  positionsTableScroll: get(state, ["positions", "tableScroll"], 0),
});

const mapDispatchToProps = {
  onGetPositions,
  onSetPositionsData,
  onSetPositionsPage,
  onSetCurrentPositionDate,
  onSetPositionsTableData,
  onSetPositionsTableScroll,
};

const withPositions = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withPositions };
